module.exports = __webpack_public_path__ + "static/img/v_3.3b5fb2e7.png";